module.exports = __webpack_public_path__ + "img/Group794.b3a2b29f.png";